import { colors } from '@flowwai-frontend/shared/style-guide'

export const dealTemplateThemes = {
   light: {
      common: {
         closeIconBGColor: colors['gray-500'],
         backgroundColor: 'bg-gray-100',
         borderColor: 'border-gray-300',
         configCard: {
            selectedBorderColor: 'border-primary-600',
            defaultBgColor: 'bg-base-white',
            defaultTextColor: 'text-gray-600'
         },
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-700',
         cardBgColor: 'bg-white',
         lineBgColor: 'bg-gray-300',
         fields: {
            sectionHeader: {
               sectionName: 'text-gray-900',
               sectionDescription: 'text-gray-700'
            },
            createCustomField: {
               titleText: 'text-gray-900',
               descriptionText: 'text-gray-600',
               fieldTypeOption: 'text-gray-700 ',
               selectedIconColor: colors['primary-600'],
               separationLineColor: 'bg-gray-300',
               searchIconColor: colors['gray-500'],
               corePropertiesTitle: 'text-gray-900',
               corePropertiesFooterBorder: 'border-gray-300',
               morePropertiesNavTex: 'text-gray-800',
               morePropertiesNavIcon: colors['gray-500'],
               backIcon: colors['gray-500']
            }
         }
      },
      header: {
         headerBGColor: 'bg-base-white',
         borderColor: 'border-b-gray-300',
         headerTitleColor: 'text-gray-900'
      }
   },
   dark: {}
}
